import { useTranslation } from 'react-i18next'

type Pillar = {
  title: string
  description: string
}

export function AI() {
  const { t } = useTranslation('ai')

  return (
    <section className="mt-[5.25rem] lg:mt-[10rem]">
      <div className="outer-container">
        <h2 className="h2">{t('title')}</h2>
        <p className="subtitle">{t('subtitle')}</p>

        <p className="body text-center text-neutral-800 max-w-3xl mx-auto mt-6 lg:mt-10">
          {t('intro')}
        </p>

        <div className="grid gap-4 md:gap-6 mt-10 lg:mt-[4.5rem] md:grid-cols-3 max-w-md md:max-w-none mx-auto">
          {(t('pillars', { returnObjects: true }) as Pillar[]).map(
            (pillar, index) => (
              <div
                key={index}
                className="border bg-white border-neutral-600/10 rounded-xl shadow-md p-6 lg:p-8"
              >
                <h3 className="h3">{pillar.title}</h3>
                <p className="body mt-2 lg:mt-3 text-neutral-600">
                  {pillar.description}
                </p>
              </div>
            )
          )}
        </div>

        <p className="mt-8 lg:mt-12 text-center font-display font-bold text-base md:text-xl text-neutral-800">
          {t('outro')}
        </p>
      </div>
    </section>
  )
}
